import { render, staticRenderFns } from "./ordercenter.vue?vue&type=template&id=024084c0&scoped=true&"
import script from "./ordercenter.vue?vue&type=script&lang=js&"
export * from "./ordercenter.vue?vue&type=script&lang=js&"
import style0 from "./ordercenter.vue?vue&type=style&index=0&id=024084c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024084c0",
  null
  
)

export default component.exports